import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=2548acc2&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2548acc2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2548acc2')) {
      api.createRecord('2548acc2', component.options)
    } else {
      api.reload('2548acc2', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=2548acc2&scoped=true&", function () {
      api.rerender('2548acc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2rYR2oHuJ35SY/JS/comp/Accordion.vue"
export default component.exports